import { render, staticRenderFns } from "./job-corrective-action-status.component.vue?vue&type=template&id=6f44e295"
import script from "./job-corrective-action-status.component.ts?vue&type=script&lang=ts&external"
export * from "./job-corrective-action-status.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f44e295')) {
      api.createRecord('6f44e295', component.options)
    } else {
      api.reload('6f44e295', component.options)
    }
    module.hot.accept("./job-corrective-action-status.component.vue?vue&type=template&id=6f44e295", function () {
      api.rerender('6f44e295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-corrective-action-status/job-corrective-action-status.component.vue"
export default component.exports